<app-filter-header title="Filtrar ocupacions" i18n-title (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row col">
    <app-form-text-edit id="tramos-filter-codi" class="col-sm-3" i18n-label label="Codi" [(value)]="this.filter.SomId" number></app-form-text-edit>
    <app-filter-text-edit id="tramos-filter-descripcio" class="col-sm-9" i18n-label label="Descripció" [(value)]="this.filter.descripcio" contains></app-filter-text-edit>
    <app-form-text-edit id="tramos-filter-numPlaces" class="col-sm-9" i18n-label label="Núm places" [(value)]="this.filter.numPlazas" number></app-form-text-edit>
  </div>
</div>
